var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlexDepIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.852,
    height: 18,
    viewBox: "0 0 10.852 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6166",
    "data-name": "Group 6166",
    transform: "translate(-17078 1561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9021",
    "data-name": "Path 9021",
    d: "M44.364,34.274c-.808-.011-1.616-.029-2.424-.031a1.507,1.507,0,0,1-1.616-1.024A1.861,1.861,0,0,1,40.8,31.28c2.106-2.227,4.191-4.479,6.286-6.718a1.45,1.45,0,0,1,2.255-.123,1.775,1.775,0,0,1-.17,2.512q-1.776,1.9-3.556,3.8c-.109.117-.209.244-.338.394.931.013,1.806.022,2.681.037.645.011.972.493,1.444,1.066.436.529.082,1.353-.407,1.847-.66.667-1.329,1.323-2.089,2.078.776.836,1.452,1.559,2.123,2.289a1.705,1.705,0,0,1-.413,2.831,1.37,1.37,0,0,1-1.643-.408q-1.568-1.756-3.125-3.524a1.705,1.705,0,0,1,.019-2.37c.181-.2.381-.389.573-.583Z",
    transform: "translate(17038.504 -1584.521)",
    fill: "#dfdfdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9022",
    "data-name": "Path 9022",
    d: "M183.652,409.359l4.737-4.825a.4.4,0,0,1,.576,0l1.654,1.685a.42.42,0,0,1,0,.587l-4.737,4.825a.4.4,0,0,1-.576,0l-1.654-1.685A.42.42,0,0,1,183.652,409.359Z",
    transform: "translate(16897.807 -1958.054)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_254",
    "data-name": "Ellipse 254",
    cx: 1.567,
    cy: 1.596,
    rx: 1.567,
    ry: 1.596,
    transform: "translate(17085.197 -1546.193)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9023",
    "data-name": "Path 9023",
    d: "M10.735,2.39,2.347,10.934a.4.4,0,0,1-.566,0L.117,9.24a.413.413,0,0,1,0-.577L8.5.119a.4.4,0,0,1,.566,0l1.664,1.694A.413.413,0,0,1,10.735,2.39Z",
    transform: "translate(17078 -1561)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexDepIcon);
export default __webpack_public_path__ + "static/media/flex_dep_icon.fea708b4b61fcf0f23313551c5c0b8ce.svg";
export { ForwardRef as ReactComponent };